import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if cookie consent has been given
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (cookieConsent) {
      return; // Already consented or declined
    }
    
    // Check if age has been verified
    const ageVerified = localStorage.getItem('ageVerified');
    if (ageVerified !== 'true') {
      return; // Don't show until age is verified
    }
    
    // Show cookie consent after a delay
    const timeoutId = setTimeout(() => {
      setIsVisible(true);
    }, 1500);
    
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-40 max-w-xs animate-slide-up">
      <div className="glass-strong rounded-xl p-4 shadow-2xl border border-brown-200/50">
        <div className="flex items-start space-x-2 mb-3">
          <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-brown-600 to-brown-800 rounded-lg flex items-center justify-center">
            <Cookie className="w-4 h-4 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-bold text-brown-900 mb-1">
              Cookies
            </h3>
            <p className="text-xs text-brown-700 leading-relaxed">
              We use cookies to improve your experience. 
            </p>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="flex-shrink-0 text-brown-600 hover:text-brown-900 transition-colors p-1"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        
        <div className="flex gap-2 mb-2">
          <button
            onClick={handleAccept}
            className="flex-1 px-3 py-1.5 bg-gradient-to-r from-brown-700 to-brown-900 text-white rounded-lg text-xs font-semibold hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-300"
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 px-3 py-1.5 glass text-brown-900 rounded-lg text-xs font-semibold hover:bg-white/40 transition-all duration-300"
          >
            Decline
          </button>
        </div>
        
        <Link
          to="/cookie-policy"
          data-discover="true"
          className="text-xs text-brown-600 hover:text-brown-900 underline text-center block"
        >
          Learn more
        </Link>
      </div>
    </div>
  );
};

export default CookieConsent;

